import React, { useMemo } from 'react';
import { buildHeatmapGrid, heatmapHasData, heatmapLevel, WEEKDAY_LABELS } from '../summaryFormatters';
import { VIOLATION_VOCAB } from '../summaryVocab';

const HOURS = Array.from({ length: 24 }, (_, hour) => hour);
const LEGEND = ['0', '1–2', '3–5', '6–10', '> 10'];

/** ТЗ №1 §9.2. Пустые ячейки = 0; weekday 1=Пн; время — локальное каждой камеры. */
const Heatmap = ({ cells, vocab = VIOLATION_VOCAB }) => {
  const grid = useMemo(() => buildHeatmapGrid(cells, vocab.countKey), [cells, vocab.countKey]);
  if (!heatmapHasData(cells, vocab.countKey)) {
    return (
      <section className="sum-card">
        <h2 className="sum-card-title">{vocab.heatmapTitle}</h2>
        <p className="sum-muted">{vocab.emptyText}</p>
      </section>
    );
  }
  return (
    <section className="sum-card">
      <div className="sum-card-head">
        <h2 className="sum-card-title">{vocab.heatmapTitle}</h2>
        <span className="sum-tz">Локальное время каждой камеры</span>
      </div>
      <div className="sum-heat-scroll">
        <div className="sum-heat">
          {grid.map((row, weekdayIndex) => (
            <div className="sum-heat-row" key={weekdayIndex}>
              <span className="sum-heat-day">{WEEKDAY_LABELS[weekdayIndex + 1]}</span>
              {row.map((count, hour) => (
                <span
                  key={hour}
                  className={`sum-heat-cell sum-heat-cell--${heatmapLevel(count)}`}
                  title={`${WEEKDAY_LABELS[weekdayIndex + 1]}, ${String(hour).padStart(2, '0')}:00 — ${count}`}
                />
              ))}
            </div>
          ))}
          <div className="sum-heat-row sum-heat-hours">
            <span className="sum-heat-day" />
            {HOURS.map((hour) => (
              <span key={hour} className="sum-heat-hour">{hour % 2 === 0 ? hour : ''}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="sum-heat-legend">
        {LEGEND.map((label, level) => (
          <span key={level}><i className={`sum-heat-cell sum-heat-cell--${level}`} /> {label}</span>
        ))}
      </div>
    </section>
  );
};

export default Heatmap;
